import produce from 'immer';

import {
    BEGIN_STEP,
    BEGIN_NEXT_STEP,
    BEGIN_PREVIOUS_STEP,
    SET_STEP_DATA,
    SET_PAGE_LOADING,
    //
    ADD_WORKING_AREA_SPECIFICATION,
    REMOVE_WORKING_AREA_SPECIFICATION,
    CLEAR_WORKING_AREA_SPECIFICATIONS,
} from '../constants/specifications';

//
import {
    MIN_SPECIFICATIONS_PAGE_STEP,
    MAX_SPECIFICATIONS_PAGE_STEP,
} from '../../constants/specificationsPageSteps';

import { LOGOUT } from '../constants/session';

//
const initialState = {
    page: {
        step: {
            current: 0,
            data: {},
        },
        workingArea: {
            specifications: [],
            //
        },
        loading: false,
    },
};

export default produce((draft, action) => {
    const { payload } = action;

    switch (action.type) {

        case BEGIN_STEP:
        case BEGIN_NEXT_STEP:
        case BEGIN_PREVIOUS_STEP: {
            const { step, data } = payload;
            const next = (action.type === BEGIN_STEP) ?
                step : draft.page.step.current + step;

            if (next < MIN_SPECIFICATIONS_PAGE_STEP ||
                next > MAX_SPECIFICATIONS_PAGE_STEP) break;

            Object.assign(draft.page.step.data, data);
            draft.page.step.current = next;

            break;
        }

        case SET_PAGE_LOADING: {
            draft.page.loading = payload;
            break;
        }

        case SET_STEP_DATA: {
            Object.assign(draft.page.step.data, payload);
            break;
        }
    
        //

        case ADD_WORKING_AREA_SPECIFICATION: {
            const specifications = draft.page.workingArea.specifications;

            let index = specifications.length;
            const data = {
                ...payload,
                color: {
                    hue: (index * (360 / 12) + Math.random() * 10) % 360,
                    saturation: 40 + Math.random() * 10, // 40–50%
                    lightness: 88 + Math.random() * 5, // 88–93%
                },
            };

            addParent: if (payload.parent) {
                const parent = specifications.find(function (specification) {
                    return specification.article === payload.parent;
                });

                if (!parent) { break addParent; }

                // Calculate new index
                index = specifications.indexOf(parent) + 1;
                
                // Assign restaurant & color
                data.restaurant = parent.restaurant;
                data.color = parent.color;
            }

            specifications.splice(index, 0, data);
            break;
        }

        case REMOVE_WORKING_AREA_SPECIFICATION: {
            const index = draft.page.workingArea.specifications.findIndex(function (item) {
                return item.article === payload;
            });

            if (index !== -1) {
                draft.page.workingArea.specifications.splice(index, 1);
            }
            
            break;
        }

        case CLEAR_WORKING_AREA_SPECIFICATIONS: {
            draft.page.workingArea.specifications = [];
            break;
        }

        case LOGOUT: {
            break;
        }

        default:
            break;
    }
}, initialState);
